/*
 * @Author: Chris 
 * @Date: 2022-07-28 10:58:45 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-17 13:42:29
 */
<template>
  <div id="ordinary" class="layouts_oridnary">
    <HeaderOrdinary></HeaderOrdinary>
    <div class="ordinary_body">
      <div class="body_menu">
        <Menu></Menu>
      </div>
      <div class="body_right">
        <Breadcrumb></Breadcrumb>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderOrdinary from "../components/headerOrdinary/index.vue";
import Menu from "../components/menu/index.vue";
import Breadcrumb from "../components/breadcrumb/index.vue";
export default {
  name: "ordinary",
  components: {
    HeaderOrdinary,
    Menu,
    Breadcrumb,
  }
};
</script>

<style lang="scss" scoped>
.layouts_oridnary {
  width: 100%;
  height: 100vh;
  .ordinary_body {
    width: 100%;
    height: calc(100vh - 3.75rem);
    background: #e5e5e5;
    display: flex;

    .body_menu {
      height: 100%;
      width: 13.75rem;
      background: #ffffff;
      box-shadow: 0.125rem 0.125rem 0.25rem rgba(0, 0, 0, 0.16);
      z-index: 10;
    }

    .body_right {
      width: calc(100% - 13.75rem);
    }
  }
}
</style> 